import { Link } from '@tanstack/react-router';
import { Button } from '../components/Button';

export function NotFoundRoute() {
  return (
    <div className="h-full w-full grid place-items-center px-5">
      <div className="text-center">
        <div className="font-display text-6xl font-bold text-ink/30">404</div>
        <h1 className="mt-2 font-display text-2xl font-bold">Square is empty.</h1>
        <p className="mt-2 text-ink-muted">There's nothing on this square. Move along.</p>
        <Link to="/" className="inline-block mt-6">
          <Button>Back to start</Button>
        </Link>
      </div>
    </div>
  );
}
